import { SubscriptionTier } from '@upright/common/activities/contact-forms/company-subscription/subscription-tiers';
import { SubscriptionRequest } from '@upright/common/activities/contact-forms/company-subscription/types';
import { getHubspotFormSubmitParams } from '../../../../../common/activities/hubspot/get-hubspot-form-submit-params';

type AdvancedFormFields = {
  company: string;
  firstName: string;
  lastName: string;
  email: string;
  message: string;
  promoCode: string;
  companyId: string;
  gaClientId: string;
};

/**
 * OA: Not in use as of 4/2023. Still worth to keep present in codebase as long as the tiered subscription modal is used;
 * we might want to bring this back. Search for this same comment to spot other locations with this thing.
 */
// const standardTierFormId = '64235517-d4b7-4b2a-82b1-a2f97139eccc';

const advancedTierFormId = '0cbdae8c-9960-4d4c-acee-e7bc275e364d';

export async function submitCompanyPlatformSubscriptionToHubspot(data: SubscriptionRequest) {
  const { url, init } = getHubspotFormSubmitParams(getFormId(data.tier), getFormFields(data));
  const response = await fetch(url, init);
  if (response.ok) {
    return { success: true };
  } else {
    const json = (await response.json()) as { message: string };
    throw Error(`Form rejected: ${json.message}`);
  }
}

function getFormId(tier: SubscriptionTier) {
  switch (tier) {
    case SubscriptionTier.FREE:
      throw Error('The free tier form has moved to server. This error should never happen.');
    case SubscriptionTier.STANDARD:
    case SubscriptionTier.DEMO:
    case SubscriptionTier.ADVANCED:
      return advancedTierFormId;
  }
}

function getFormFields(data: SubscriptionRequest) {
  switch (data.tier) {
    case SubscriptionTier.FREE:
      throw Error('The free tier form has moved to server. This error should never happen.');
    case SubscriptionTier.STANDARD:
    case SubscriptionTier.DEMO:
    case SubscriptionTier.ADVANCED:
      return getAdvancedTierFormFields(data);
  }
}

function getAdvancedTierFormFields(data: SubscriptionRequest): AdvancedFormFields {
  return {
    company: data.companyInfo.name,
    firstName: data.personalInfo.firstName,
    lastName: data.personalInfo.lastName,
    email: data.personalInfo.email,
    promoCode: data.promoCode || '',
    companyId: data.companyInfo.companyId || '',
    message: data.message || '',
    gaClientId: data.gaClientId || '',
  };
}
